(function(){
  var R=document.querySelector('.ap-root');
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;

  if(!reduce){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
    document.querySelectorAll('.reveal').forEach(function(e){io.observe(e);});
  } else { document.querySelectorAll('.reveal').forEach(function(e){e.classList.add('in');}); }

  if(!reduce){
    var px=[].slice.call(document.querySelectorAll('[data-parallax]')), ticking=false;
    function par(){ px.forEach(function(el){
      var r=el.getBoundingClientRect(), vh=innerHeight;
      if(r.bottom<-100||r.top>vh+100)return;
      var prog=(r.top+r.height/2 - vh/2)/vh;
      var amt=parseFloat(el.getAttribute('data-parallax'))||.15;
      var cine=el.classList.contains('cine');
      el.style.transform='translateY('+(prog*amt*r.height*-1).toFixed(1)+'px)'+(cine?' scale(1.12)':'');
    }); ticking=false;}
    function onS(){ if(!ticking){ requestAnimationFrame(par); ticking=true; } }
    addEventListener('scroll',onS,{passive:true}); addEventListener('resize',par); par();
  }

  if(!reduce){
    var sf=document.querySelector('.sticky-feat');
    var sfTrack=sf?sf.querySelector('.media-col'):null;
    var sfGrid=sfTrack?sfTrack.parentElement:null;
    var mqM=matchMedia('(max-width:860px)'), sfTick=false;
    function sfMode(){ if(!sf)return;
      if(mqM.matches){ sf.classList.add('js-horiz'); }
      else { sf.classList.remove('js-horiz'); if(sfTrack) sfTrack.style.transform=''; } }
    function sfUpdate(){ sfTick=false;
      if(!sf||!sfTrack||!sf.classList.contains('js-horiz')) return;
      var total=sf.offsetHeight-innerHeight;
      var top=sf.getBoundingClientRect().top;
      var passed=Math.min(Math.max(-top,0),total);
      var prog=total>0?passed/total:0;
      var max=sfTrack.scrollWidth-sfGrid.clientWidth; if(max<0)max=0;
      sfTrack.style.transform='translateX('+(-prog*max).toFixed(1)+'px)'; }
    function sfOnScroll(){ if(!sfTick){ requestAnimationFrame(sfUpdate); sfTick=true; } }
    sfMode(); sfUpdate();
    addEventListener('scroll',sfOnScroll,{passive:true});
    addEventListener('resize',function(){ sfMode(); sfUpdate(); });
  }

  function countUp(el){var target=parseInt(el.getAttribute('data-count'),10),dur=1200,t0=null;
    function fmt(v){return v.toLocaleString('it-IT');}
    function step(ts){if(!t0)t0=ts;var p=Math.min((ts-t0)/dur,1);var v=Math.floor((1-Math.pow(1-p,3))*target);
      el.textContent=fmt(v);if(p<1)requestAnimationFrame(step);else el.textContent=fmt(target);}
    requestAnimationFrame(step);}
  if(!reduce){var cio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){countUp(e.target);cio.unobserve(e.target);}});},{threshold:.6});
    document.querySelectorAll('[data-count]').forEach(function(e){cio.observe(e);});}

  var GAP=12,EDGE=20;
  function sizeUGC(){var N=matchMedia('(max-width:768px)').matches?3:5;
    document.querySelectorAll('.ugc-track').forEach(function(t){var w=t.getBoundingClientRect().width,sw=(w-EDGE*2-GAP*(N-1))/N;if(sw<=0)return;
      t.querySelectorAll('.ugc-slide').forEach(function(s){s.style.flex='0 0 '+sw+'px';s.style.width=s.style.minWidth=s.style.maxWidth=sw+'px';});});}
  function autoUGC(){document.querySelectorAll('.ugc-track').forEach(function(t){if(t.__x)return;var d=parseInt(t.getAttribute('data-autoscroll')||'4000',10);
    t.__x=setInterval(function(){var m=t.scrollWidth-t.clientWidth;if(m<=2)return;if(t.scrollLeft>=m-2)t.scrollTo({left:0,behavior:'smooth'});else{var n=t.scrollLeft+t.clientWidth;if(n>m)n=m;t.scrollTo({left:n,behavior:'smooth'});}},d);});}
  sizeUGC();autoUGC();addEventListener('load',sizeUGC);addEventListener('resize',sizeUGC);

  R.querySelectorAll('[data-top]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();scrollTo({top:0,behavior:'smooth'});});});
})();
